/* src/components/Fastboard/Fastboard.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	not_equal,
	space,
	subscribe,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { onMount } from "svelte";
import { tippy_hide_all } from "../../actions/tippy";
import RedoUndo from "../RedoUndo";
import ZoomControl from "../ZoomControl";
import PageControl from "../PageControl";
import Toolbar from "../Toolbar";

function create_if_block_3(ctx) {
	let toolbar;
	let current;

	toolbar = new Toolbar({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				language: /*language*/ ctx[2],
				config: /*config*/ ctx[3].toolbar
			}
		});

	return {
		c() {
			create_component(toolbar.$$.fragment);
		},
		m(target, anchor) {
			mount_component(toolbar, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const toolbar_changes = {};
			if (dirty & /*app*/ 1) toolbar_changes.app = /*app*/ ctx[0];
			if (dirty & /*theme*/ 2) toolbar_changes.theme = /*theme*/ ctx[1];
			if (dirty & /*language*/ 4) toolbar_changes.language = /*language*/ ctx[2];
			if (dirty & /*config*/ 8) toolbar_changes.config = /*config*/ ctx[3].toolbar;
			toolbar.$set(toolbar_changes);
		},
		i(local) {
			if (current) return;
			transition_in(toolbar.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(toolbar.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(toolbar, detaching);
		}
	};
}

// (75:4) {#if config.redo_undo?.enable !== false}
function create_if_block_2(ctx) {
	let redoundo;
	let current;

	redoundo = new RedoUndo({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				language: /*language*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(redoundo.$$.fragment);
		},
		m(target, anchor) {
			mount_component(redoundo, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const redoundo_changes = {};
			if (dirty & /*app*/ 1) redoundo_changes.app = /*app*/ ctx[0];
			if (dirty & /*theme*/ 2) redoundo_changes.theme = /*theme*/ ctx[1];
			if (dirty & /*language*/ 4) redoundo_changes.language = /*language*/ ctx[2];
			redoundo.$set(redoundo_changes);
		},
		i(local) {
			if (current) return;
			transition_in(redoundo.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(redoundo.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(redoundo, detaching);
		}
	};
}

// (78:4) {#if config.zoom_control?.enable !== false}
function create_if_block_1(ctx) {
	let zoomcontrol;
	let current;

	zoomcontrol = new ZoomControl({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				language: /*language*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(zoomcontrol.$$.fragment);
		},
		m(target, anchor) {
			mount_component(zoomcontrol, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const zoomcontrol_changes = {};
			if (dirty & /*app*/ 1) zoomcontrol_changes.app = /*app*/ ctx[0];
			if (dirty & /*theme*/ 2) zoomcontrol_changes.theme = /*theme*/ ctx[1];
			if (dirty & /*language*/ 4) zoomcontrol_changes.language = /*language*/ ctx[2];
			zoomcontrol.$set(zoomcontrol_changes);
		},
		i(local) {
			if (current) return;
			transition_in(zoomcontrol.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(zoomcontrol.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(zoomcontrol, detaching);
		}
	};
}

// (83:4) {#if config.page_control?.enable !== false}
function create_if_block(ctx) {
	let pagecontrol;
	let current;

	pagecontrol = new PageControl({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				language: /*language*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(pagecontrol.$$.fragment);
		},
		m(target, anchor) {
			mount_component(pagecontrol, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const pagecontrol_changes = {};
			if (dirty & /*app*/ 1) pagecontrol_changes.app = /*app*/ ctx[0];
			if (dirty & /*theme*/ 2) pagecontrol_changes.theme = /*theme*/ ctx[1];
			if (dirty & /*language*/ 4) pagecontrol_changes.language = /*language*/ ctx[2];
			pagecontrol.$set(pagecontrol_changes);
		},
		i(local) {
			if (current) return;
			transition_in(pagecontrol.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(pagecontrol.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(pagecontrol, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div4;
	let div0;
	let div0_class_value;
	let t0;
	let div1;
	let div1_class_value;
	let t1;
	let div2;
	let t2;
	let div2_class_value;
	let t3;
	let div3;
	let div3_class_value;
	let div4_class_value;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*config*/ ctx[3].toolbar?.enable !== false && create_if_block_3(ctx);
	let if_block1 = /*config*/ ctx[3].redo_undo?.enable !== false && create_if_block_2(ctx);
	let if_block2 = /*config*/ ctx[3].zoom_control?.enable !== false && create_if_block_1(ctx);
	let if_block3 = /*config*/ ctx[3].page_control?.enable !== false && create_if_block(ctx);

	return {
		c() {
			div4 = element("div");
			div0 = element("div");
			t0 = space();
			div1 = element("div");
			if (if_block0) if_block0.c();
			t1 = space();
			div2 = element("div");
			if (if_block1) if_block1.c();
			t2 = space();
			if (if_block2) if_block2.c();
			t3 = space();
			div3 = element("div");
			if (if_block3) if_block3.c();
			attr(div0, "class", div0_class_value = "" + (name + "-view"));
			attr(div1, "class", div1_class_value = "" + (name + "-left"));
			toggle_class(div1, "hidden", !(/*layout*/ ctx[5] === "visible" || /*layout*/ ctx[5] === "toolbar-only"));
			attr(div2, "class", div2_class_value = "" + (name + "-bottom-left"));
			toggle_class(div2, "hidden", /*layout*/ ctx[5] !== "visible");
			attr(div3, "class", div3_class_value = "" + (name + "-bottom-right"));
			toggle_class(div3, "hidden", /*layout*/ ctx[5] !== "visible");
			attr(div4, "class", div4_class_value = "" + (name + "-root"));
			toggle_class(div4, "loading", !/*app*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div4, anchor);
			append(div4, div0);
			/*div0_binding*/ ctx[15](div0);
			append(div4, t0);
			append(div4, div1);
			if (if_block0) if_block0.m(div1, null);
			append(div4, t1);
			append(div4, div2);
			if (if_block1) if_block1.m(div2, null);
			append(div2, t2);
			if (if_block2) if_block2.m(div2, null);
			append(div4, t3);
			append(div4, div3);
			if (if_block3) if_block3.m(div3, null);
			current = true;

			if (!mounted) {
				dispose = listen(div0, "touchstart", /*focus_me*/ ctx[9], { passive: true, capture: true });
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*config*/ ctx[3].toolbar?.enable !== false) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*config*/ 8) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div1, null);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*layout*/ 32) {
				toggle_class(div1, "hidden", !(/*layout*/ ctx[5] === "visible" || /*layout*/ ctx[5] === "toolbar-only"));
			}

			if (/*config*/ ctx[3].redo_undo?.enable !== false) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*config*/ 8) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div2, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*config*/ ctx[3].zoom_control?.enable !== false) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*config*/ 8) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_1(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div2, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*layout*/ 32) {
				toggle_class(div2, "hidden", /*layout*/ ctx[5] !== "visible");
			}

			if (/*config*/ ctx[3].page_control?.enable !== false) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty & /*config*/ 8) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(div3, null);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*layout*/ 32) {
				toggle_class(div3, "hidden", /*layout*/ ctx[5] !== "visible");
			}

			if (!current || dirty & /*app*/ 1) {
				toggle_class(div4, "loading", !/*app*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			transition_in(if_block3);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			transition_out(if_block3);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div4);
			/*div0_binding*/ ctx[15](null);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			mounted = false;
			dispose();
		}
	};
}

const name = "fastboard";

function instance($$self, $$props, $$invalidate) {
	let writable;
	let boxState;
	let focusedApp;

	let $focusedApp,
		$$unsubscribe_focusedApp = noop,
		$$subscribe_focusedApp = () => ($$unsubscribe_focusedApp(), $$unsubscribe_focusedApp = subscribe(focusedApp, $$value => $$invalidate(12, $focusedApp = $$value)), focusedApp);

	let $boxState,
		$$unsubscribe_boxState = noop,
		$$subscribe_boxState = () => ($$unsubscribe_boxState(), $$unsubscribe_boxState = subscribe(boxState, $$value => $$invalidate(13, $boxState = $$value)), boxState);

	let $writable,
		$$unsubscribe_writable = noop,
		$$subscribe_writable = () => ($$unsubscribe_writable(), $$unsubscribe_writable = subscribe(writable, $$value => $$invalidate(14, $writable = $$value)), writable);

	$$self.$$.on_destroy.push(() => $$unsubscribe_focusedApp());
	$$self.$$.on_destroy.push(() => $$unsubscribe_boxState());
	$$self.$$.on_destroy.push(() => $$unsubscribe_writable());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { containerRef = void 0 } = $$props;
	let { config = {} } = $$props;
	const AppsShowToolbar = ["DocsViewer", "Slide"];
	let container;
	let layout = "hidden";
	let mounted = false;

	onMount(() => {
		if (containerRef) {
			containerRef(container);

			return () => {
				if (containerRef) containerRef(null);
			};
		}
	});

	function focus_me() {
		tippy_hide_all();
		let a = document.activeElement;
		a && a.blur && a.blur();
	}

	function div0_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			container = $$value;
			$$invalidate(4, container);
		});
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(0, app = $$props.app);
		if ('theme' in $$props) $$invalidate(1, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(2, language = $$props.language);
		if ('containerRef' in $$props) $$invalidate(10, containerRef = $$props.containerRef);
		if ('config' in $$props) $$invalidate(3, config = $$props.config);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*app*/ 1) {
			$: $$subscribe_writable($$invalidate(8, writable = app?.writable));
		}

		if ($$self.$$.dirty & /*app*/ 1) {
			$: $$subscribe_boxState($$invalidate(7, boxState = app?.boxState));
		}

		if ($$self.$$.dirty & /*app*/ 1) {
			$: $$subscribe_focusedApp($$invalidate(6, focusedApp = app?.focusedApp));
		}

		if ($$self.$$.dirty & /*$writable, $boxState, $focusedApp*/ 28672) {
			$: if (!$writable) {
				$$invalidate(5, layout = "hidden");
			} else if ($boxState === "maximized") {
				if ($focusedApp && AppsShowToolbar.some(kind => ($focusedApp || "").includes(kind))) {
					$$invalidate(5, layout = "toolbar-only");
				} else {
					$$invalidate(5, layout = "hidden");
				}
			} else {
				$$invalidate(5, layout = "visible");
			}
		}

		if ($$self.$$.dirty & /*app, container*/ 17) {
			$: try {
				if (app && container) {
					app.bindContainer(container);
					$$invalidate(11, mounted = true);
				}
			} catch(err) {
				console.error("[fastboard] An error occurred while binding container");
				console.error(err);
			}
		}

		if ($$self.$$.dirty & /*app, theme, mounted*/ 2051) {
			$: if (app && theme && mounted) {
				app.manager.setPrefersColorScheme(theme);
			}
		}
	};

	return [
		app,
		theme,
		language,
		config,
		container,
		layout,
		focusedApp,
		boxState,
		writable,
		focus_me,
		containerRef,
		mounted,
		$focusedApp,
		$boxState,
		$writable,
		div0_binding
	];
}

class Fastboard extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, not_equal, {
			app: 0,
			theme: 1,
			language: 2,
			containerRef: 10,
			config: 3
		});
	}
}

export default Fastboard;